import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { GetBaseUrl } from "app/helper/getBaseUrl";
import { ITicketCategory } from "app/interfaces/i-ticket-category";
import { Observable } from "rxjs";

const httpOptions = {
    headers: new HttpHeaders({ "Content-Type": "application/json" }),
};

@Injectable()
export class ApiTicketCategoryService {
    private baseUrl = GetBaseUrl.baseUrl();

    constructor(private http: HttpClient) {}

    public find(idTenant?: string): Observable<ITicketCategory[]> {
        return this.http.get<ITicketCategory[]>(
            this.baseUrl + "/ticketcategory/find?idTenant=" + idTenant
        );
    }
}
